import {z as r} from 'zod';

import {CountryV2Type, IdNameType} from '../../api/api-type';
import {CompanyKeyEnum} from '../company-const';

export const companyAddressSchema = {
    [CompanyKeyEnum.Address]: r.object({
        lang: r.string().nullish(),
        countryId: r.number().nullish(),
        countryName: r.string(),
        countryCode: r.string().nullish(),
        regionId: r.number().nullish(),
        regionName: r.string().nullish(),
        cityId: r.number().nullish(),
        cityName: r.string().nullish(),
        street: r.string(),
        houseNumber: r.string().nullish(),
        postalCode: r.string().nullish(),
        description: r.string().nullish(),
        lat: r.number().nullish(),
        lon: r.number().nullish(),
    }),
};

const companyAddressSchemaObject = r.object(companyAddressSchema);

export type CompanyAddressType = r.infer<typeof companyAddressSchemaObject>;

export type CompanyAddressFormType = {
    [CompanyKeyEnum.Address]: {
        lang: string | null;
        country: CountryV2Type | null;
        region: IdNameType | null;
        city: IdNameType | string | null;
        street: string | null;
        houseNumber: string | null;
        postalCode: string | null;
        description: string | null;
        latLng: [number, number] | null;
    };
};

/**
 * Form-only state of the address comment template: which template is picked and how much of it is
 * filled in. It drives the validation of the comment field and is never sent to the server.
 */
export type AddressCommentTemplateStateType = {
    fieldCount: number;
    filledCount: number;
};

export type CompanyAddressServerType = {
    address: Omit<CompanyAddressType['address'], 'countryName' | 'countryCode' | 'lat' | 'lon'> & {
        lat: number;
        lon: number;
    };
};
